import React, { FC, ReactNode } from "react";
import { Button } from "@mui/material";

export const ContactLink: FC<ContactLinkProps> = ({
  href,
  label,
  icon,
  iconOnly
}) => (
    <Button
      LinkComponent="a"
      href={href}
      aria-label={label}
      variant="text"
      sx={{
        display: "inline-flex",
        gap: 1,
        fontSize: iconOnly ? "2rem" : "1.5rem",
        color: theme => theme.palette.common.white,
        fontWeight: 600,
        lineHeight: 1.3,
        minWidth: 0,
        px: 2,
        ml: -2,
        transition: "opacity 0.3s ease",
        ":hover": {
          opacity: 0.6
        }
      }}
    >
      {icon}
      {!iconOnly && label}
    </Button>
  );

export interface ContactLinkProps {
  /**
   * Label for the link is necessary at all times. If iconOnly is true, then label is used as the alt text for the icon.
   */
  label: string;
  href: string;
  icon?: ReactNode;
  iconOnly?: boolean;
}
